import { ArrowRight, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import HowItWorksList from "../components/HowItWorksList";

import {
    SIGNUP_TEXT,
    HOW_IT_WORKS_STEPS,
} from "../../domain/constants/constants";

type Props = {
    onClose: () => void;
};

export default function HowItWorksPopup({ onClose }: Props) {
    const navigate = useNavigate();
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#0A1712]/75 backdrop-blur-[6px]">
            <div className="relative w-full max-w-[450px] rounded-[24px] bg-white shadow-[0_24px_70px_rgba(0,0,0,.18)]">        {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-lg border border-[#E7E3D8] bg-[#F6F4ED]"
                >
                    <X size={16} />
                </button>

                <div className="px-7 pt-6 pb-5">

                    {/* Badge */}
                    <p className="text-[11px] font-bold uppercase tracking-[3px] text-[#11815F]">
                        {SIGNUP_TEXT.providersBadge}
                    </p>

                    {/* Title */}
                    <h2 className="mt-2 font-fraunces text-[24px] leading-[30px] font-medium text-[#13211B]">
                        {SIGNUP_TEXT.howItWorksTitle}
                    </h2>

                    {/* Subtitle */}
                    <p className="mt-3 text-[15px] leading-7 text-[#70817B]">
                        {SIGNUP_TEXT.howItWorksSubtitle}
                    </p>

                    {/* Timeline */}
                    <div className="relative mt-5">

                        <div className="absolute left-[15px] top-4 bottom-4 w-px bg-[#D6EEE4]" />

                        <HowItWorksList />
                    </div>

                    {/* Divider */}
                    <div className="mt-4 border-t border-[#ECE8DD]" />

                    {/* Footer */}
                    <div className="pt-4">

                        <button
                            onClick={onClose}
                            className="flex h-11 w-full items-center justify-center rounded-xl bg-[#28A676] text-[16px] font-semibold text-white shadow-[0_8px_20px_rgba(40,166,118,.25)] transition hover:bg-[#1E8B61]"
                        >
                            {SIGNUP_TEXT.gotIt}
                        </button>

                        <button
                            onClick={() => navigate("/landing")}
                            className="mt-3 flex w-full items-center justify-center gap-2 text-[14px] font-semibold text-[#6F7D77] hover:text-[#28A676]"
                        >
                            {SIGNUP_TEXT.fullWalkthrough}
                            <ArrowRight size={18} />
                        </button>

                    </div>
                </div>
            </div>
        </div>
    );
}